import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cog Box"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cog-box',
    templateUrl: './icon-cog-box.component.html',
    styleUrls: ['./icon-cog-box.component.scss'],
    standalone: false
})
export class IconCogBoxComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
